import styled from "styled-components";

const CustomMarkerContainer = styled.div`
  position: relative;
  transform: translate(-50%, -50%);
`;

const ParcelNumberContainer = styled.div`
  position: absolute;
  height: 1.4rem;
  width: 1.4rem;
  line-height: 1.4rem;
  text-align: center;
  border-radius: 50%;
  background-color: black;
  top: -1.6rem;
  left: -0.5rem;
  z-index: 9999;
`;

export { CustomMarkerContainer, ParcelNumberContainer };
